













































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { checkMobile } from '../../utils/utils'
import { ROUTER_NAME } from '../../router'
import { LETTER_FORMAT } from '../../utils/constants'
import ExamResultWeb from '../atoms_molecules/ExamResultWeb.vue'
import ExamResultMobile from '../atoms_molecules/ExamResultMobile.vue'
import { headerState } from '../../stores/header'
import api from '../../../api/v2/api'
import Banner from '../../../api/v2/models/banner'
import { userState } from '../../stores/user'
import CommentContainer from '../organisms/CommentContainer.vue'
import { Commentable } from '../../../api/v2/models/comment'
import { examResultState } from '../../stores/exam_result'
import { getLastExamRoute } from '../../utils/setup_exam_router'
import UserUpdateFormView from '../organisms/UserUpdateFormView.vue'

@Component({
  components: {
    ExamResultWeb,
    ExamResultMobile,
    CommentContainer,
    UserUpdateFormView,
  }
})
export default class ExamResult extends Vue {
  LETTER_FORMAT = LETTER_FORMAT
  mobile: boolean = false
  banners: Banner[] = []
  get exam() {
    return examResultState.examResult
  }

  get examQScoreHistory() {
    return examResultState.examQScoreHistory
  }

  get userExam() {
    if (this.userExamId) {
      return this.exam!.userExams.find((userExam) => `${userExam.id}` == this.userExamId)
    }
    return this.exam!.userExam
  }

  get user() {
    return userState.user
  }

  get redirectNotFoundPage() {
    return examResultState.redirectNotFoundPage
  }

  get userExamId() {
    return this.$route.query.user_exam_id as string
  }

  get groupQuestions() {
    return examResultState.groupQuestions
  }

  public mounted() {
    this.mobile = checkMobile()
  }

  @Watch('$route', { immediate: true })
  changeRoute(val) {
    examResultState.requestExamResult(parseInt(this.$route.params.examId)).then(() => {
      headerState.setTitle(this.exam!.name)
      examResultState.setUserExamId(Number(this.userExamId))
      examResultState.getExamResultQuestions()
    })
    examResultState.requestExamQScoreHistories(parseInt(this.$route.params.examId))
  }

  @Watch('redirectNotFoundPage')
  changeRedirectNotFoundPage(val) {
    if (val) {
      examResultState.setRedirectNotFoundPage({ status: false })
      this.redirectToNotFoundPage()
    }
  }

  redirectToNotFoundPage() {
    this.$router.push({
      name: ROUTER_NAME.NOT_FOUND
    })
  }

  async created() {
    try {
      this.banners = await Promise.resolve(api.banner.index({ type: 'exam_result' }))
      userState.getUser()
    } catch (e) { }
  }

  // getBanner(position) {
  //   var result = this.banners.find((banner) => {
  //     return banner.position == position
  //   })
  //   return result
  // }

  gotoTop() {
    this.$router.push({
      name: ROUTER_NAME.MY_EXAM_LIST
    })
  }

  get commentable(): Commentable {
    return {
      commentableId: this.userExam!.id,
      commentableType: "UserExam"
    }
  }

  getIsPreviusExamResultRouter(){
    const found = getLastExamRoute()
    return !!found
  }
  backToExamResult() {
    const found = getLastExamRoute()
    if (found) {
      this.$router.push(found)
    }
  }
}
